// AI Recommendations for LMS & Statistics pages

export const getLMSModerationRecommendations = () => [
  {
    id: '1',
    title: 'Prove in attesa di revisione',
    type: 'Attenzione',
    diamondRange: '12 prove > 24h',
    reason:
      "Ci sono 12 prove in attesa di revisione da più di 24 ore. Rivedi le prove per mantenere l'engagement degli utenti.",
    ctaLabel: 'Rivedi prove',
  },
  {
    id: '2',
    title: 'Contenuti segnalati',
    type: 'Urgente',
    diamondRange: '3 segnalazioni',
    reason:
      '3 contenuti sono stati segnalati dalla community. Verifica e prendi azione per mantenere un ambiente positivo.',
    ctaLabel: 'Modera contenuti',
  },
  {
    id: '3',
    title: 'Pattern di approvazione',
    type: 'Opportunità',
    diamondRange: '95% approvazione',
    reason:
      'Le prove di "Raccolta differenziata" hanno un tasso di approvazione del 95%. Considera di automatizzare la validazione.',
    ctaLabel: 'Configura automazione',
  },
]

export const getLMSProgrammingRecommendations = () => [
  {
    id: '1',
    title: 'Challenge stagionale consigliata',
    type: 'Opportunità',
    diamondRange: 'Primavera in arrivo',
    reason:
      'Primavera in arrivo: crea una challenge "Orto Urbano" per sfruttare la stagionalità e aumentare l\'engagement.',
    ctaLabel: 'Crea challenge',
  },
  {
    id: '2',
    title: 'Sondaggio scaduto',
    type: 'Attenzione',
    diamondRange: 'Solo 45% risposte',
    reason:
      'Il sondaggio "Preferenze mobilità" è scaduto con solo 45% di risposte. Considera di rilanciarlo con incentivi.',
    ctaLabel: 'Rilancia sondaggio',
  },
  {
    id: '3',
    title: 'Evento con alta richiesta',
    type: 'Trend',
    diamondRange: '50 in lista attesa',
    reason:
      "Il Workshop Compostaggio ha 50 persone in lista d'attesa. Pianifica una seconda data entro 2 settimane.",
    ctaLabel: 'Aggiungi data',
  },
]

export const getLMSCoursesRecommendations = () => [
  {
    id: '1',
    title: 'Corso con alto abbandono',
    type: 'Attenzione',
    diamondRange: '60% abbandono modulo 3',
    reason:
      'Il corso "Economia Circolare Avanzata" ha un tasso di abbandono del 60% al modulo 3. Semplifica i contenuti o aggiungi video.',
    ctaLabel: 'Rivedi corso',
  },
  {
    id: '2',
    title: 'Richiesta nuovo corso',
    type: 'Opportunità',
    diamondRange: '23 richieste ultimo mese',
    reason:
      'Gli utenti hanno richiesto un corso su "Moda Sostenibile" 23 volte nell\'ultimo mese. Alta domanda per questo topic.',
    ctaLabel: 'Crea corso',
  },
  {
    id: '3',
    title: 'Corso Zero Waste 101 popolare',
    type: 'Trend',
    diamondRange: '95% completamento, 4.8★',
    reason:
      'Zero Waste 101 ha il 95% di completamento e rating 4.8/5. Crea un livello avanzato per capitalizzare il successo.',
    ctaLabel: 'Crea livello avanzato',
  },
]

export const getPlatformAnalyticsRecommendations = () => [
  {
    id: '1',
    title: 'Picco di attività serale',
    type: 'Trend',
    diamondRange: '20:00-22:00 peak',
    reason:
      "L'engagement è massimo tra le 20:00 e le 22:00. Pianifica comunicazioni e lanci in questa fascia oraria.",
    ctaLabel: 'Pianifica comunicazioni',
  },
  {
    id: '2',
    title: 'Calo retention settimana 2',
    type: 'Attenzione',
    diamondRange: '-20% settimana 2',
    reason:
      'Gli utenti mostrano un calo di engagement nella seconda settimana. Implementa una campagna di re-engagement.',
    ctaLabel: 'Crea campagna',
  },
  {
    id: '3',
    title: 'Crescita utenti Milano +35%',
    type: 'Opportunità',
    diamondRange: '+35% ultimi 30gg',
    reason:
      'Milano mostra una crescita del 35% negli ultimi 30 giorni. Considera di espandere i partner locali.',
    ctaLabel: 'Espandi partner',
  },
]

export const getImpactIndicesRecommendations = () => [
  {
    id: '1',
    title: 'Indice CO2 in crescita',
    type: 'Trend',
    diamondRange: '+18% questo mese',
    reason:
      "L'indice di riduzione CO2 è cresciuto del 18% questo mese grazie alle challenge mobilità. Comunica il successo alla community.",
    ctaLabel: 'Crea comunicazione',
  },
  {
    id: '2',
    title: 'Plastica monouso ancora alta',
    type: 'Attenzione',
    diamondRange: 'Fermo al 45%',
    reason:
      "L'indice plastica monouso è fermo al 45%. Lancia una challenge specifica per accelerare il cambiamento.",
    ctaLabel: 'Lancia challenge',
  },
  {
    id: '3',
    title: 'Economia circolare in crescita',
    type: 'Opportunità',
    diamondRange: '+12% al mese',
    reason:
      "L'indice economia circolare cresce del 12% al mese. Evidenzia questo successo nel report trimestrale.",
    ctaLabel: 'Prepara report',
  },
]
